import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// The PWA service worker caused stale-bundle "blank content" screens after a
// redeploy (cached index.html pointing at a now-404 bundle), both in browsers
// and inside the native WKWebView app. The site works fine with normal HTTP
// caching (hashed bundles) and the native app always loads fresh, so we no
// longer register a worker — and we proactively remove any worker + caches that
// a previous version may have left behind. (service-worker.js is now a
// self-destruct kill-switch that finishes the cleanup for already-stuck users.)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {});
}
if (window.caches) {
  caches
    .keys()
    .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
    .catch(() => {});
}

// iOS WKWebView occasionally leaves freshly-laid-out content UNPAINTED (a blank
// white screen while the header/footer show fine, and content only flashes in
// on navigation). The most reliable cure is to force the scrolling layer to
// flush its pixels: nudge a 1px scroll on the app-shell scroller + a cheap GPU
// repaint. We fire it several times after launch (React mounts asynchronously,
// so the content may not exist on the very first frame) and again whenever the
// app returns to the foreground.
function nudgeRepaint() {
  const main = document.querySelector(".app-scroll");
  if (main) {
    const top = main.scrollTop;
    main.scrollTop = top + 1;
    requestAnimationFrame(() => {
      main.scrollTop = top;
    });
  }
  const root = document.getElementById("root");
  if (root) {
    root.style.transform = "translateZ(0)";
    requestAnimationFrame(() => {
      root.style.transform = "";
    });
  }
}
[80, 300, 700, 1400, 2500].forEach((ms) => setTimeout(nudgeRepaint, ms));
window.addEventListener("load", () => setTimeout(nudgeRepaint, 60));
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) nudgeRepaint();
});
window.addEventListener("focus", nudgeRepaint);
window.addEventListener("pageshow", nudgeRepaint);
